// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aHA1","textarea":"styles_textarea__3SR0x"};